import { getConfig } from '@superbet-group/web.lib.config';
import { Country } from '@superbet-group/web.types';
import {
    createCTRestClient,
    createRestClient,
    processResponse,
    RestClient,
} from '@superbet-group/web.lib.rest';
import { getClientSourceParam } from '@superbet-group/web.lib.vue-utilities';

import { defaultHttpTimeoutMs } from '@core/constants';

export default class RestService {
    private readonly ctRestClient: RestClient = createCTRestClient(
        getConfig().country.host,
        defaultHttpTimeoutMs,
        getClientSourceParam(),
        true,
    );

    public getShops(): Promise<any> {
        return processResponse(this.ctRestClient.get(getConfig().services.playerAccountManagement.getClubs));
    }

    public getCountries(): Promise<any> {
        return processResponse(this.ctRestClient.get(getConfig().services.playerAccountManagement.getCountries));
    }

    // eslint-disable-next-line class-methods-use-this
    public getPaymentProvidersLogos(country: Country): Promise<any> {
        const restClient = createRestClient(`${getConfig().services.paymentProvidersUrl}`, defaultHttpTimeoutMs);
        return processResponse(restClient.get(`/payment-providers?target=${country}`));
    }
}
